import { colors } from "@toddle-edu/ds-theme";

export const cardStyles = {
  titleStyle: {
    marginBottom: 0,
    flex: 1,
    maxWidth: "fit-content",
  },
  standardsStyle: {
    fontSize: "1.4rem",
    lineHeight: "2rem",
  },
  separatorStyle: {
    color: colors.neutral400,
  },
};
